module.exports = __webpack_public_path__ + "img/Coupe_Front_Side_Left_Transparent.2dea861d.svg";